import React, { useEffect, useState } from "react";
import { CalendlyLink } from "./SiteHeader";

// Calendly-only conversion extras for solution pages. Keyed by slug so each page opts in with its own voice.
const STICKY = {
  "pre-approval": (city) => ({
    b: "Get the number before you get attached.",
    sub: `One free call, a few documents, a real ${city ? `${city} ` : ""}pre-approval in 1–3 business days. Zero mortgage-speak.`,
  }),
};
const EXIT_ART = "/brand/mascot-call-me.png";
const exitCopy = (slug, city) => ({
  art: EXIT_ART,
  b: "Hey, we just met you. And this is crazy.",
  p: slug === "pre-approval"
    ? `But here's our number—and a real ${city ? `${city} ` : ""}pre-approval in 1–3 business days. Free, no credit pull until you say so, no mortgage-speak.`
    : `But here's our number. Fifteen minutes with us${city ? ` in ${city}` : ""} and you'll know exactly where you stand. Free, no pressure, no mortgage-speak.`,
});

export function SolutionStickyBar({ slug, city }) {
  const cfg = STICKY[slug]?.(city);
  const key = `hm_solbar_${slug}`;
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(key) === "1");
  useEffect(() => {
    if (!cfg) return undefined;
    const onScroll = () => {
      const hero = document.querySelector(".solution-hero");
      if (hero) setShow(hero.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [cfg]);
  if (!cfg || dismissed || !show) return null;
  return (
    <div className="rt-holdbar" role="status" data-testid="solution-sticky-bar">
      <span className="rt-holdbar-dot" aria-hidden="true" />
      <b>{cfg.b}</b>
      <span className="rt-holdbar-sub">{cfg.sub}</span>
      <CalendlyLink className="btn" testId="solution-sticky-cta">Let's Get This Going</CalendlyLink>
      <button type="button" className="rt-holdbar-x" aria-label="Dismiss" onClick={() => { sessionStorage.setItem(key, "1"); setDismissed(true); }} data-testid="solution-sticky-dismiss">×</button>
    </div>
  );
}

// Exit intent (desktop mouse-out / mobile back-scroll), once per visitor per page.
export function SolutionExitCard({ slug, city }) {
  const cfg = exitCopy(slug, city);
  const key = `hm_exit_${slug}`;
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!cfg || localStorage.getItem(key) === "1") return undefined;
    let lastY = window.scrollY, armed = false;
    const arm = setTimeout(() => { armed = true; }, 12000);
    const fire = () => { if (!armed) return; localStorage.setItem(key, "1"); setOpen(true); cleanup(); };
    const onLeave = (e) => { if (e.clientY <= 0) fire(); };
    const onScroll = () => { const y = window.scrollY; if (y > 900 && lastY - y > 260) fire(); lastY = y; };
    const cleanup = () => { document.removeEventListener("mouseleave", onLeave); window.removeEventListener("scroll", onScroll); clearTimeout(arm); };
    document.addEventListener("mouseleave", onLeave);
    window.addEventListener("scroll", onScroll, { passive: true });
    return cleanup;
  }, [cfg, key]);
  if (!cfg || !open) return null;
  return (
    <div className="rt-textme sol-exit" role="dialog" aria-label={cfg.b} data-testid="solution-exit-card">
      <button type="button" className="rt-holdbar-x" aria-label="Close" onClick={() => setOpen(false)} data-testid="solution-exit-close">×</button>
      <img src={cfg.art} alt="" className="rt-textme-art sol-exit-art" />
      <b>{cfg.b}</b>
      <p>{cfg.p}</p>
      <div className="sol-exit-actions">
        <CalendlyLink className="btn" testId="solution-exit-cta">So call us, maybe</CalendlyLink>
        <small className="rt-textme-fine"><CalendlyLink className="sol-exit-definitely" testId="solution-exit-definitely">Definitely.</CalendlyLink> · Free conversation. No obligation.</small>
      </div>
    </div>
  );
}
